// extracted by css-extract-rspack-plugin
export default {"profile":"VFRWm","avatar_override":"jRIeu","avatarOverride":"jRIeu","#":"nuAJS"};